<template>
    <v-form>
        <v-row>
            <v-col cols="6">
                <ValidatableTextField v-model:form="form" label="Name" :field="'name'" />
            </v-col>
            <v-col cols="12">
                <Autocomplete v-model:selected-items="form.inventory_type_id" v-model:form="form" :field-name="'inventory_type_id'" :items="inventoryTypes" :loading="fetchingInventoryTypes" label="Inventory Type" />
            </v-col>
        </v-row>
    </v-form>
</template>

<script setup lang="ts">
import { useInjectSubmitForm } from '@shared/composables/action-dialog/useInjectSubmitForm';
import { type ITransactionType } from '@app/purchase/transaction-type/models/TransactionType';
import { useTransactionTypeRepository } from '@app/purchase/transaction-type/repositories/useTransactionTypeRepository';
import { useInventoryTypeRepository } from '@app/land-hold/inventory-type/repositories/useInventoryTypeRepository.ts';

const props = defineProps({
    item: {
        type: Object as PropType<ITransactionType>,
        required: true,
    },
});

const update = useTransactionTypeRepository().command.update(props.item.id, props.item);
const form = update.form;
useInjectSubmitForm(update.execute);

const { inventoryTypes, fetchingInventoryTypes } = useInventoryTypeRepository().query.list();
</script>
